





































  // defineComponent rather than <script setup>: vue-loader 15.9.8 used here does not compile <script setup>
  import { computed, defineComponent, PropType, ref } from 'vue'
  import { Stocks } from '@one/types'
  import useCurrentInstance from '~/utils/useCurrentInstance'

  interface ProductStocks {
    warehouses: { byId: Record<string, Stocks.Responses.WarehouseStocks> }
  }

  interface Props {
    productId: string
    stocks: ProductStocks | null
    unit: string
    stockVisibilityModeHidden: boolean
  }

  const HOURS_PER_DAY = 24

  export default defineComponent({
    name: 'OneProductSupplierStocks',
    props: {
      productId: {
        type: String,
        required: true,
      },
      stocks: {
        type: null as unknown as PropType<ProductStocks | null>,
        default: null,
      },
      unit: {
        type: String,
        default: '',
      },
      stockVisibilityModeHidden: {
        type: Boolean,
        default: false,
      },
    },
    setup(props: Props) {
      const vm = useCurrentInstance()

      const expanded = ref(false)

      const getWarehouse = computed(() => vm.$store.getters['stocks/getWarehouse'])
      const getProductOrderQuantityInWarehouse = computed(() => vm.$store.getters['stocks/getProductOrderQuantityInWarehouse'])

      const supplierStocks = computed(() => {
        return Object.values(props.stocks?.warehouses.byId ?? {})
          .filter(stock => stock.supplierWarehouse && stock.available)
          .map(stock => ({
            id: stock.warehouseId,
            label: stock.warehouseLabel || getWarehouse.value(stock.warehouseId)?.name || '',
            quantity: Math.floor(getProductOrderQuantityInWarehouse.value(props.productId, stock.warehouseId) ?? stock.quantity ?? 0),
            // supplier warehouses show their own delivery time instead of the shipping time
            deliveryTime: stock.deliveryTime ?? getWarehouse.value(stock.warehouseId)?.deliveryTime,
          }))
          // the fastest supplier first, suppliers without a delivery time last
          .sort((a, b) => (a.deliveryTime ?? Infinity) - (b.deliveryTime ?? Infinity))
      })

      const visibleStocks = computed(() => expanded.value ? supplierStocks.value : supplierStocks.value.slice(0, 1))
      const hiddenStocksCount = computed(() => supplierStocks.value.length - visibleStocks.value.length)

      // deliveryTime is given in hours; anything longer than a day is shown in working days
      const formatDeliveryTime = (hours: number): string => {
        return hours <= HOURS_PER_DAY
          ? `${hours} ${vm.$t('product_page.hour')}`
          : vm.$t('product_page.working_days', { count: Math.ceil(hours / HOURS_PER_DAY) }) as string
      }

      return {
        expanded,
        supplierStocks,
        visibleStocks,
        hiddenStocksCount,
        formatDeliveryTime,
      }
    },
  })
